import React from 'react';
import './PackageDetails.css';

const PackageDetails = ({ isOpen, onClose, packageData, onEnquiryClick }) => {
  if (!isOpen || !packageData) return null;

  const { detailedPackage } = packageData;
  if (!detailedPackage) return null;

  return (
    <div className="package-overlay" onClick={onClose}>
      <div className="package-modal" onClick={(e) => e.stopPropagation()}>
        <div className="package-header">
          <h2>{packageData.title}</h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="package-content">
          <div className="package-intro">
            <p>{detailedPackage.overview}</p>
          </div>

          <section>
            <h3><i className="fas fa-route"></i> Itinerary Details</h3>
            
            {detailedPackage.itineraryDetails.map((day, index) => (
              <div key={index} className="day-itinerary">
                <h4>Day {day.day}: {day.title}</h4>
                <p>{day.description}</p>
              </div>
            ))}
          </section>

          <div className="package-info-grid">
            <div className="info-card">
              <h4><i className="fas fa-clock"></i> Duration</h4>
              <p>{detailedPackage.packageInfo.duration}</p>
            </div>
            <div className="info-card">
              <h4><i className="fas fa-car"></i> Type of Trip</h4>
              <p>{detailedPackage.packageInfo.tripType}</p>
            </div>
            <div className="info-card">
              <h4><i className="fas fa-map-marker-alt"></i> Start City</h4>
              <p>{detailedPackage.packageInfo.startCity}</p>
            </div>
            <div className="info-card">
              <h4><i className="fas fa-flag-checkered"></i> End City</h4>
              <p>{detailedPackage.packageInfo.endCity}</p>
            </div>
            <div className="info-card">
              <h4><i className="fas fa-rupee-sign"></i> Package Price</h4>
              <p>{detailedPackage.packageInfo.price}</p>
            </div>
          </div>

          <div className="package-includes-excludes">
            <div className="includes">
              <h3><i className="fas fa-check-circle"></i> Package Includes</h3>
              <ul>
                {detailedPackage.includes.map((item, index) => (
                  <li key={index}><i className="fas fa-check"></i> {item}</li>
                ))}
              </ul>
            </div>

            <div className="excludes">
              <h3><i className="fas fa-times-circle"></i> Package Excludes</h3>
              <ul>
                {detailedPackage.excludes.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="package-services">
            <div className="service-icons">
              {detailedPackage.services.map((service, index) => {
                const getServiceIcon = (serviceName) => {
                  const service = serviceName.toLowerCase();
                  switch (service) {
                    case 'hotel':
                    case 'accommodation':
                      return 'hotel';
                    case 'wildlife lodge':
                    case 'lodge':
                      return 'tree';
                    case 'sightseeing':
                    case 'sight seeing':
                      return 'eye';
                    case 'transfer':
                    case 'transportation':
                      return 'car';
                    case 'meals':
                    case 'meal':
                    case 'food':
                      return 'utensils';
                    case 'desert camp':
                    case 'camp':
                    case 'camping':
                      return 'campground';
                    case 'safari':
                    case 'camel safari':
                    case 'jeep safari':
                      return 'binoculars';
                    case 'guide':
                    case 'tour guide':
                      return 'user-tie';
                    case 'boat ride':
                    case 'boating':
                    case 'boat':
                      return 'ship';
                    case 'romance':
                    case 'romantic':
                      return 'heart';
                    case 'cultural shows':
                    case 'cultural':
                    case 'performance':
                      return 'music';
                    case 'activities':
                    case 'adventure':
                      return 'mountain';
                    default:
                      return 'concierge-bell';
                  }
                };
                
                return (
                  <div key={index} className="service-item">
                    <i className={`fas fa-${getServiceIcon(service)}`}></i>
                    <span>{service}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="package-action">
            <button 
              className="btn-primary package-enquiry-btn"
              onClick={() => {
                if (onEnquiryClick) {
                  onEnquiryClick(packageData);
                }
              }}
            >
              <i className="fas fa-envelope"></i> Enquire Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageDetails;